module.exports = __webpack_public_path__ + "img/tick-icon.a72c2903.svg";